import DownloadIcon from '@mdi/svg/svg/download.svg?react';
import { Button, ButtonMenu, MDIIcon } from '@solinkcorp/solink-components';
import { type DownloadOption } from 'components/PublicPages/types/camera.types';
import React from 'react';
import useLocale from 'src/hooks/useLocale';

interface CameraDownloadButtonProps {
  downloadOption: DownloadOption;
}

const CameraDownloadButton: React.FC<CameraDownloadButtonProps> = ({ downloadOption }) => {
  const locale = useLocale();
  const hasBothDownloadOptions = downloadOption?.['mp4'] && downloadOption?.['zip'];

  const handleDownload = (type: 'mp4' | 'zip') => {
    const link = document.createElement('a');
    if (downloadOption?.[type].url) {
      link.href = downloadOption[type].url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      {hasBothDownloadOptions ? (
        <ButtonMenu
          buttonIcon={<MDIIcon icon={DownloadIcon} />}
          buttonIconOnly={true}
          buttonType="clear"
          buttonTooltip={locale.download.download}
          buttonClass="download-button"
          colorMode="dark"
          menuItems={[
            {
              action: () => handleDownload('mp4'),
              text: locale.spa.downloadMp4,
              type: 'action',
            },
            {
              action: () => handleDownload('zip'),
              text: locale.spa.downloadZip,
              type: 'action',
            },
          ]}
        />
      ) : (
        <Button
          onClick={() => handleDownload('mp4')}
          className="download-button"
          icon={<MDIIcon icon={DownloadIcon} />}
          tooltip={locale.download.download}
          type="clear"
          iconOnly
        />
      )}
    </>
  );
};

export default CameraDownloadButton;
